import CompanyDetails from './company-details';
export default CompanyDetails;